import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Styled } from './ControlledInputBar.styles';
const ControlledInputBar = ({ name, placeholder, onChange, }) => {
    const [value, setValue] = useState('');
    const handleChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue.length <= 280) {
            setValue(inputValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(name, inputValue);
        }
    };
    return (_jsx(Styled.ControlledInputBar, { placeholder: placeholder, value: value, multiline: true, onChange: handleChange }));
};
ControlledInputBar.displayName = 'ControlledInputBar';
export default ControlledInputBar;
//# sourceMappingURL=ControlledInputBar.js.map